import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useI18nTl from '@/hooks/useI18nTl'
import Transactions from '../../ProfitSharing/Transactions.vue'



import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OrderProfitSharing',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  orderId: {
    type: String,
    required: true,
    default: '0',
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Order')



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Transactions, {
    orderId: props.orderId,
    showQueryFilter: false
  }, null, 8, ["orderId"]))
}
}

})